// @ts-expect-error No types available for mixpanel-browser
import mixpanel from 'mixpanel-browser';
import { useActiveUser } from './useActiveUser';
import { useEffect, useMemo } from 'react';

/**
 * Explicitly exporting this non-hook method for legacy class components.
 */
export const track = (
  event: string,
  properties: Record<string, any> & { user?: string },
) => {
  if (
    properties.user &&
    !properties.user.toLowerCase().startsWith('test-user-')
  ) {
    mixpanel?.track?.(event, properties);
  }
};

export const useMixpanel = () => {
  const user = useActiveUser();

  const userId = user?.id;

  useEffect(() => {
    if (
      !user?.id ||
      !user?.profile ||
      user.id.toLowerCase().startsWith('test-user-')
    ) {
      return;
    }

    mixpanel?.identify?.(user?.id);
    mixpanel?.people?.set({
      $name: user?.profile?.name,
      $email: user?.profile?.email,
      $user_id: user?.id,
    });
  }, [user]);

  return useMemo(
    () => ({
      track: (event: string, properties?: Record<string, any>) => {
        track(event, { user: userId, ...properties });
      },
    }),
    [userId],
  );
};
